"use client";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
const heroContentImg1Tr = "/brand/legacy/instagram-hero-content-img1-tr.png";
const heroContentImg1En = "/brand/legacy/instagram-hero-content-img1-en.png";
import Breadcrumb from "~/common/components/Breadcrumb";
import Image from "~/common/components/CustomImage";
import { LEAD_CAPTURE_MODAL_VARIANTS, openLeadCaptureModal } from "~/common/lib/leadCaptureModal";

import SectionFeatureIcons from "./SectionFeatureIcons";
import styles from "./InstagramSection1.module.scss";

const InstagramSection1 = ({ locale }) => {
  const { t } = useTranslation();

  const triggerChatbot = () => {
    openLeadCaptureModal({
      variant: LEAD_CAPTURE_MODAL_VARIANTS.BOOK_DEMO,
      source: "instagram-section-1",
    });
  };

  return (
    <div className={clsx(styles.chatbotSection1, "card")}>
      <div className={clsx(styles.breadcrumb, "card")}>
        <Breadcrumb
          segments={[t("instagram.breadcrumb.products"), t("instagram.breadcrumb.instagramPostManagement")]}
        />
      </div>
      <div className={styles.chatbotSection1Content}>
        <div className={styles.chatbotSection1ContentLeft}>
          <h1 className={clsx("pal-section-title", styles.chatbotSection1Title)} title={t("instagram.section1.title")}>{t("instagram.section1.title")}</h1>
          <p className={clsx("pal-section-desc", styles.chatbotSection1Desc)}>{t("instagram.section1.description")}</p>
          <button onClick={triggerChatbot}>{t("instagram.section1.bookADemo")}</button>
        </div>
        <div className={styles.chatbotSection1ContentRight}>
          <Image
            src={locale === "tr" ? heroContentImg1Tr : heroContentImg1En}
            alt={t("instagram.section1.heroImageAlt")}
            width={485}
            height={586}
          />
        </div>
      </div>
      <div className={styles.chatbotSection1Content2}>
        <h4 className={styles.chatbotSection1Content2Title}>{t("instagram.sectionFeatureIcons.title")}</h4>
        <p className={styles.chatbotSection1Content2Desc}>{t("instagram.sectionFeatureIcons.description")}</p>
        <div className={styles.chatbotSection1Content2Dialog}>
          <SectionFeatureIcons />
        </div>
      </div>
    </div>
  );
};

export default InstagramSection1;
